function normalize(value: unknown): string {
  if (value === null || value === undefined) return '';
  const str = String(value);

  return str
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();
}

function getNestedValue(obj: Record<string, unknown>, path: string): unknown {
  return path.split('.').reduce((current: unknown, key) => (current as Record<string, unknown>)?.[key], obj);
}

// RUTs are stored without dots ("12345678-9") but shown and typed with them
// ("12.345.678-9"); comparing both sides without dots or dash matches any format.
function compactRut(value: string): string {
  return value.replace(/[.-]/g, '');
}

interface TableFilterOptions {
  rutFields?: string[];
}

export function useTableFilter(searchableFields: string[], { rutFields = [] }: TableFilterOptions = {}) {
  return function multiWordAccentInsensitiveFilter(
    _value: string,
    query: string,
    item?: unknown,
  ): boolean {
    if (!query) return true;

    const actualItem = (item as Record<string, unknown>)?.raw || item;

    const fieldValues = searchableFields.map(field =>
      getNestedValue(actualItem as Record<string, unknown>, field),
    );

    const combinedText = fieldValues
      .filter(field => field !== null && field !== undefined)
      .map(field => normalize(field))
      .join(' ');

    const ruts = rutFields
      .map(field => getNestedValue(actualItem as Record<string, unknown>, field))
      .filter(field => field !== null && field !== undefined && field !== '')
      .map(field => compactRut(normalize(field)));

    const normalizedWords = normalize(query).split(/\s+/).filter(Boolean);

    return normalizedWords.every((word: string) => combinedText.includes(word) ||
      (compactRut(word) !== '' && ruts.some(rut => rut.includes(compactRut(word)))));
  };
}
